import React from 'react';
import { ProfileAttributes } from '@loyalty/shared-common/profile-api-client';

interface Props {
  profile: ProfileAttributes;
}

export function ProfileDisplayName({ profile }: Props) {
  if (!profile.firstName && !profile.lastName) {
    return <>{profile.email}</>;
  }

  return <>{`${profile.firstName || ''} ${profile.lastName || ''}`.trim()}</>;
}
